import React, {useState} from 'react';
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {MDBBtn, MDBBtnGroup, MDBCard, MDBCardBody, MDBCardImage, MDBCol, MDBRipple, MDBRow} from "mdb-react-ui-kit";
import {Rating, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import LightBoxFs from "../LightBoxFs/LightBoxFs";

const OneDigitalProductDetail = (props) => {
    // console.log(props.elm)
    let navigate = useNavigate();
    const [toggler, setToggler] = useState(false);
    const [value, setValue] = React.useState(5);
    const [favorXIcon,setxfavorIcon]= React.useState('Добавить в избранное')
    const [carXticon,setCarticon]= React.useState('Добавить в корзину')
    var defsize=props.elm.SizesAvailability[0]
    if (props.elm.selected_Size!=null){
        defsize=props.elm.selected_Size
    }
    const [currsize, setCurrSize]= React.useState(defsize)



    var favorIcon='Добавить в избранное'
    var carticon=""
    var carticonStyle="success"
    var favoriconStyle="success"
    var sizeColor="light"
    var favor= JSON.parse( localStorage.getItem('favorites'))
    var cart= JSON.parse( localStorage.getItem('cart'))

    if (favor == null)
    {       favor=[]
        localStorage.setItem('favorites',JSON.stringify(favor));
    } else {
        favor= JSON.parse( localStorage.getItem('favorites'))
    }

    if (cart == null)
    {       cart=[]
        localStorage.setItem('cart',JSON.stringify(cart));
    } else {
        cart= JSON.parse( localStorage.getItem('cart'))
    }
    if (cart.filter(elm=>elm.name==props.elm._id).length> 0)
    {
        carticon='Убрать из корзины';
        carticonStyle="danger"
    }
    else
    {
        carticon='Добавить в корзину';
        carticonStyle="success"
    }

    if (favor.filter(elm=>elm.name==props.elm._id).length> 0)
    {
        favorIcon='💗';
        favoriconStyle="danger"
    }
    else
    {
        favoriconStyle="success"
        favorIcon='Добавить в избранное';
    }

    function SetSize(nme)
    {
        setCurrSize(nme)
    }
    function setInFavor()
    {
        if (favor.filter(elm=>elm.name==props.elm._id).length== 0)
        {
            toast.success('Добавлено в избранное', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });

            favor= JSON.parse( localStorage.getItem('favorites'))
            let el={"name": props.elm._id, "size": currsize, "count":1}
            favor.push(el)
            localStorage.setItem('favorites',JSON.stringify(favor));
            props.callbak(favor.length)
            setxfavorIcon('💗')


        }else
        {
            toast.error('Удалено из избранного', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            favor= JSON.parse( localStorage.getItem('favorites'))
            favor = favor.filter((n) => {return n.name != props.elm._id});
            localStorage.setItem('favorites',JSON.stringify(favor));
            props.callbak(favor.length)
            setxfavorIcon('🤍')
        }
    }

    function setInCart()
    {
        if (cart.filter(elm=>elm.name==props.elm._id).length== 0)
        {
            toast.success('Добавлено в корзину', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            cart= JSON.parse( localStorage.getItem('cart'))
            let el={"name": props.elm._id, "size": currsize, "count":1}
            cart.push(el)
            localStorage.setItem('cart',JSON.stringify(cart));
            props.callbak(cart.length)
            setxfavorIcon('1')
        }else
        {
            toast.error('Удалено из корзины', {
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                // pauseOnHover: true,
                draggable: false,
                theme: "dark",
            });
            cart= JSON.parse( localStorage.getItem('cart'))
            cart = cart.filter((n) => {return n.name != props.elm._id});
            localStorage.setItem('cart',JSON.stringify(cart));
            props.callbak(cart.length)
            setxfavorIcon('2')
        }
    }

    function myttt()
    {
        navigate(props.urlx);
    }
    return (
        <>
            {/*<ToastContainer />*/}
            <MDBRow className="justify-content-center mb-0 "  >
                <MDBCol md="12" xl="10">
                    <MDBCard className="shadow-0  rounded-3 mt-2 mb-0 ">
                        <MDBCardBody style={{ backgroundColor: "#382b2f" }}>
                            <MDBRow >
                                <MDBCol md="12" lg="3" className="mb-4 mb-lg-0 glass0">
                                    <Stack spacing={2}>
                                        <MDBRipple
                                            rippleColor="light"
                                            rippleTag="div"
                                            className="bg-image rounded hover-zoom hover-overlay "
                                        >
                                            <MDBCardImage
                                                src={props.elm.RIMG}
                                                fluid
                                                position='center'
                                                className="h-100"
                                            />
                                            <a>
                                                <div
                                                    onClick={() => setToggler(!toggler)}
                                                    className="mask"
                                                    style={{ backgroundColor: "rgba(251, 251, 251, 0.15)" }}
                                                ></div>
                                            </a>
                                        </MDBRipple>

                                        <MDBRipple
                                            rippleColor="light"
                                            rippleTag="div"
                                            className="bg-image rounded hover-zoom hover-overlay "
                                        >

                                            {props.elm.imagesUrls.map((elm, key) => (
                                                <MDBCardImage
                                                    src={elm}
                                                    fluid
                                                    position='center'
                                                    className="hh-10"
                                                />
                                                // <img src={baseUrl_back+props.elm} className="hh-10"/>
                                            ))}

                                            <a>
                                                <div
                                                    onClick={() => setToggler(!toggler)}
                                                    className="mask"
                                                    style={{ backgroundColor: "rgba(251, 251, 251, 0.15)" }}
                                                ></div>
                                            </a>
                                        </MDBRipple>
                                    </Stack>
                                </MDBCol>
                                <MDBCol md="6">
                                    <h5>{props.elm.name}</h5>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        артикул: {props.elm.article}
                                    </Typography>
                                    <Rating
                                        name="simple-controlled"
                                        precision={0.5}
                                        value={props.elm.Rating}
                                        onChange={(event, newValue) => {
                                            setValue(newValue);
                                        }}
                                    />
                                    <div className="mt-1 mb-0 text small">
                                        <Typography variant="body" display="block" gutterBottom>
                                            Тип продукта: подписка на сервис
                                        </Typography>






                                        <Typography variant="body" display="block" gutterBottom>
                                            <a>Срок подписки:</a>{props.elm.Season.map((elm, key) => (
                                            <a> {elm}, </a>
                                        ))}
                                        </Typography>
                                        <Typography variant="body" display="block" gutterBottom>
                                            {props.elm.description.map((elm, key) => (
                                                <p> {elm}</p>
                                            ))}
                                        </Typography>
                                        {/*<p> {props.elm.description}</p>*/}

                                    </div>

                                    {/*<p className="text-truncate mb-4 mb-md-0">*/}
                                    {/*    {props.elm.description}*/}
                                    {/*</p>*/}
                                </MDBCol>
                                <MDBCol
                                    md="6"
                                    lg="3"
                                    className="border-sm-start-none border-start"
                                >
                                    <div className="d-flex flex-row align-items-center mb-1">
                                        <h4 className="mb-1 me-1">{props.elm.Price} ₽ㅤ</h4>
                                        <span className="text-danger">
                      <s>{props.elm.PriceBefore} ₽</s>
                    </span>
                                    </div>
                                    <h6 className="text-success">{props.elm.availability_text}</h6>
                                    <div className="d-flex flex-column mt-4">
                                        <MDBBtn href="https://t.me/Go_bananas_bot"  target="_ blank" outline color={favoriconStyle} size="sm" className="mt-2">
                                            Купить в Telegram боте
                                        </MDBBtn>
                                        {/*<MDBBtn onClick={setInCart} outline color={carticonStyle} size="sm">*/}
                                        {/*    {carticon}*/}
                                        {/*</MDBBtn>*/}
                                        <MDBBtn onClick={setInFavor} outline color={favoriconStyle} size="sm" className="mt-2">
                                            {favorIcon}
                                        </MDBBtn>


                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <LightBoxFs imgs={props.elm.imagesUrls} show={toggler}/>
            {/*<LightBoxFs imgs={sources} show={toggler}/>*/}
        </>
    );
};

export default OneDigitalProductDetail;